<template>
    <swiper
      style="background-color: #1867c0; height: 80px"
      :breakpoints="{
      320: { slidesPerView: 3, spaceBetween: 10 },
      480: { slidesPerView: 3, spaceBetween: 20 },
      640: { slidesPerView: 4, spaceBetween: 20 },
      960: { slidesPerView: 8, spaceBetween: 20 }
    }"
      loop
      :modules="modules"
      :autoplay="{ delay: 2500 }"
      scrollbar
      @swiper="onSwiper"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="logo in logos" :key="logo.id">
        <img :src="logo.src" :alt="logo.alt" height="30" width="100" />
      </swiper-slide>
    </swiper>
  </template>
  

<script>
import { Autoplay } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';
import 'swiper/css';
import 'swiper/css/autoplay';


export default {
  components: {
    Swiper,
    SwiperSlide,
  },
  data() {
    return {
      modules: [Autoplay],
      logos: [
        {
          id: 1,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/MAKITA.png',
          alt: 'Logo 1',
        },
        {
          id: 2,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/3M.png',
          alt: 'Logo 2',
        },
        {
          id: 3,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/AUSTROMEX.png',
          alt: 'Logo 2',
        },
        {
          id: 4,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/URREA.png',
          alt: 'Logo 2',
        },
        {
          id: 5,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/SURTEK.png',
          alt: 'Logo 2',
        },
        {
          id: 6,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/RESISTOL.png',
          alt: 'Logo 2',
        },
        {
          id: 7,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/IUSA.png',
          alt: 'Logo 2',
        },
        {
          id: 8,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/HIGH_POWER.png',
          alt: 'Logo 2',
        },
        {
          id: 9,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/WD40.png',
          alt: 'Logo 2',
        },
        {
          id: 10,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/DEWALT.png',
          alt: 'Logo 2',
        },
        {
          id: 11,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/BOSCH.png',
          alt: 'Logo 2',
        },
        {
          id: 12,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/STANLEY.png',
          alt: 'Logo 2',
        },
        {
          id: 13,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/BLACK-AND-DECKER.png',
          alt: 'Logo 2',
        },
        {
          id: 14,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/PHILLIPS.png',
          alt: 'Logo 2',
        },
        {
          id: 15,
          src: 'https://indar.mx/assets/customers/img/png/Proveedores/FANDELI.png',
          alt: 'Logo 2',
        },
      ],
    };
  },
  methods: {
    onSwiper(swiper) {
   
    },
    onSlideChange() {
      
    },
  },
};
</script>

<style scoped>
.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
.swiper-slide img {
  display: block;
  margin: auto;
  filter: brightness(0) invert(1);
}
</style>